import React from 'react';
import { useMsal } from '@azure/msal-react';
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  Avatar,
  Container
} from '@mui/material';
import { Login as LoginIcon, Business } from '@mui/icons-material';
import { loginRequest } from '../authConfig';

const Login = () => {
  const { instance } = useMsal();

  const handleLogin = () => {
    instance.loginRedirect(loginRequest);
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          py: 4
        }}
      >
        <Card sx={{ width: '100%', maxWidth: 400 }}>
          <CardContent sx={{ textAlign: 'center', py: 6 }}>
            <Avatar
              sx={{
                width: 80,
                height: 80,
                bgcolor: 'primary.main',
                mx: 'auto',
                mb: 3
              }}
            >
              <Business sx={{ fontSize: 40 }} />
            </Avatar>

            <Typography variant="h4" gutterBottom sx={{ fontWeight: 600 }}>
              CV Manager
            </Typography>

            <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
              HR Applicant Management System
            </Typography>

            <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
              Sign in with your Azure AD account to access the recruitment dashboard
            </Typography>

            <Button
              variant="contained"
              size="large"
              onClick={handleLogin}
              startIcon={<LoginIcon />}
              sx={{
                px: 4,
                py: 1.5,
                fontSize: '1.1rem',
                borderRadius: 2
              }}
            >
              Sign In
            </Button>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default Login;
